import { translations } from 'core/locales/translations';

const DEFAULT_LOCALE = 'en';

export const i18n = (locale, key) => {
  return (translations[locale] && translations[locale][key]) || translations[DEFAULT_LOCALE][key] || key;
}
